
export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://articzsystems.com/api';

export const API_CONTENT_URL = `${API_BASE_URL}/wp-json/wp/v2`;

export const API_TIMEOUT = 10000;
